import { render, staticRenderFns } from "./custompage.vue?vue&type=template&id=5f88b480&scoped=true"
import script from "./custompage.vue?vue&type=script&lang=js"
export * from "./custompage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88b480",
  null
  
)

export default component.exports